<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller" />

    <!-- HEADER -->
    <div class="pt-5 pb-8 header bg-gradient-dark pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-12 col-md-12">
              <h1 class="text-white display-3">Estado de clientes</h1>
              <p
                class="mt-0 text-white"
              >Reporte de estado de clientes. Puede consultar solo un cliente a la vez.</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="card card-body">
            
              <SearchDealer :inputData.sync="dealer._data" :options="dealer.options" />
              
              <ClientStatusReportButton/>
            
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div v-if="seller" class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <!-- COMPONENTE PRINCIPAL -->
          <div class="row">            
            <div class="col-lg-12">
              <div class="card card-body">
                <div class="mb-3 text-right card-header">
                    <button class="btn btn-secondary btn-sm" type="button" v-if="isLoading" disabled>
                        <img src="@/assets/img/excel-ico.png" width="24px" alt="Exportar"> Cargando...
                    </button>
                    <download-excel
                      class="btn btn-secondary btn-sm"
                      :data="excel.data"
                      :fields="excel.fields"
                      :name="excel.name"
                      type="xls"
                      v-if="excel.name && !isLoading"
                      :worksheet="excel.worksheet">
                      <img src="@/assets/img/excel-ico.png" width="24px" alt="Exportar"> Exportar
                  </download-excel>
                </div>
                <div class="table-responsive">                
                  <table class="table align-items-center table-flush table-hover">
                    <thead class="thead-light">
                      <tr >
                        <th v-for="(title, index) of tableHeaders" :key="'header_'+index">
														{{title}}
                        </th>
                      </tr>
                    </thead>
                    <tbody >
                      <tr v-if="isLoading">
                        <td class="py-4 text-center text-muted" colspan="18">
                          <i class="fas fa-spinner fa-spin mr-2 text-primary"></i> Cargando...
                        </td>
                      </tr>
                      <template v-if="!isLoading && reportData && reportData.length">
                        <tr v-for="seller of reportData" :key="seller.codigo">
                          <td>
                              {{seller.codigo}}
                          </td>
                          <td>
                              {{seller.rut}}
                          </td>
                          <td>
                              {{seller.nombre}}
                          </td>
                          <td>
                              {{seller.nombre}}
                          </td>
                          <td>
                              {{seller.direccion}}
                          </td>
                          <td>
                              {{seller.comuna}}
                          </td>
                          <td>
                              {{seller.plan}}
                          </td>
                          <td>
                              {{seller.avisosActivos}}
                          </td>
                          <td>
                              {{seller.premium}}
                          </td>
                          <td>
                              {{seller.activosPremium}}
                          </td>
                          <td>
                              {{seller.topSpot}}
                          </td>
                          <td>
                              {{seller.activosTopSpot}}
                          </td>
                          <td>
                            {{seller.whatsapp}}
                          </td>
                          <td>
                            {{seller.whatsappPremium}}
                          </td>
                          <td>
                            {{seller.callConnect}}
                          </td>
                          <td>
                            {{seller.santanderConsumer}}
                          </td>
                          <td>
                            {{seller.integracion}}
                          </td>
                          <td>
                            {{seller.integracionLeads}}
                          </td>
                          <td>
                            {{seller.bloqueado}}
                          </td>
                        </tr>
                      </template>
                    </tbody>                  
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import sysMsgs from '@/helpers/system.message'
import ClientStatusReportButton from './_ClientStatusReportButton'
import financeServices from '@/services/finance.services';
export default {
	name: "ClientStatusReport",
  components: { ClientStatusReportButton },
	data() {
		return {
      isLoading: false,
			loading: false,
      controller: {
						title: "Finanzas / Reporte Clientes",
						mainRouter: "/finanzas/reporte-clientes"        
				},
				tableHeaders: [
          "Cód. Cliente",
          "RUT",
          "Nombre Legal", 
          "Nombre Fantasía", 
          "Dirección", 
          "Comuna", 
          "Plan", 
          "Avisos Activos", 
          "Premium", 
          "Activos Premium", 
          "TopSpot", 
          "Activos TopSpot", 
          "WhatsApp", 
          "WhatsApp Premium",
          "CallConnect",
          "Santander Consumer",
          "Integración",
          "Integración Leads",
          "Bloqueado"],
				dealer:{
					_data: null,
					options: {
						active: true
				}
			},
      reportData: [],
			seller: null,
      excel: {
        data: [],
        name: null,
        worksheet: "Clientes",
        fields: {
          "Código" : "codigo",
          "Rut" : "rut",
          "Nombre Legal" : "nombre",
          "Nombre Fantasia" : "nombre",
          "Dirección" : "direccion",
          "Comuna" : "comuna",
          "Plan" : "plan",
          "Avisos Activos" : "avisosActivos",
          "Premium" : "premium",
          "Activos Premium" : "activosPremium",
					"TopSpot" : "topSpot",
          "Activos TopSpot" : "activosTopSpot",
          "WhatsApp" : "whatsapp",
          "WhatsApp Premium": "whatsappPremium",
          "CallConnect": "callConnect",
          "Santander Consumer" : "santanderConsumer",
          "Integración" : "integracion",
          "Integración Leads" : "integracionLeads",
          "Bloqueado" : "bloqueado"
        }
      }
		}
	},
  watch:{
    'dealer._data': {
      deep: true,
      handler(data) {
				this.seller = data;
				if(data) {
          this.getClientStatusReport(data.cod_cliente);
				}
      }
    },
    'reportData': {
			deep: true,
			handler(data) {
        this.excel.data = [];
				if (data && data.length > 0 && this.seller) {
          const record = data.find(item => item.codigo === this.seller.cod_cliente);
          this.excel.name = this.getExcelName();
          this.excel.data.push(record);
				}
			}
		}
  },
	methods: {
    getClientStatusReport(codCliente) {
      this.isLoading = true;
			financeServices.getClientStatusReport(codCliente).then(data => {
        const { data: records }  = data;
        this.reportData = records && records.length ? records : [];
        this.isLoading = false;
			}).catch(error => {
        this.isLoading = false;
        console.log('Component: ClientStatusReport, FN: getClientStatusReport', error.message);
        sysMsgs.getMessage('No se pudo consultar el reporte del cliente.', 'error');
      });
    },
    getExcelName() {
      let fileDate = new Date();
      return `clientes_${moment().format('DD-MM-YYYY')}-${fileDate.getSeconds().toString()}${fileDate.getMilliseconds().toString()}.xls`;
    }
	}
}
</script>